module.exports = __webpack_public_path__ + "assets/icon-funnel.543f0cd2.svg";